<template>
	<section class="header">
		<ul class="nav" ref="nav">
			<li class="logo">
				<router-link class="nav-link active" aria-current="page" to="/"><img src="/assets/img/bosb-owl-profile-logo.jpg" alt="The Barred Owl Stringband"></router-link>
			</li>
			<!-- <li>
				<router-link class="nav-link active" aria-current="page" to="/">home</router-link>
			</li> -->
			<li>
				<router-link class="nav-link active" aria-current="page" to="/info">Info</router-link>
			</li>
			<li>
				<router-link class="nav-link active" aria-current="page" to="/epk">Press Kit</router-link>
			</li>
			<li>
				<router-link class="nav-link active" aria-current="page" to="/contact">Contact</router-link>
			</li>
		</ul>
	</section>
</template>

<script>

	export default {
		name: "headerInc",
		mounted() {
			console.log('Header nav element:', this.$refs.nav);
			console.log("Header height on mount:", this.$refs.nav.offsetHeight);

		}
	};
</script>

